import { GridFilterCellProps } from '@progress/kendo-react-grid'
import { Language } from 'api/Clients/Types/Language'
import { useAppSelector } from 'store'

import { ItemProps, multiSelectFilterCell, SelectValue } from './MultiSelectFilterCell'

const languagesOperator = (value: string, selectedValues: SelectValue[]) => {
  if (selectedValues.length === 0) {
    return true
  }

  return selectedValues.find((selectedName) => {
    return value === selectedName
  })
}

export interface LanguagesFilterCellProps {
  items?: (languages: Language[]) => ItemProps[]
}

export const LanguagesFilterCell: React.FC<GridFilterCellProps & LanguagesFilterCellProps> = (
  props
) => {
  const languages = useAppSelector((state) => state.clients.language)

  return multiSelectFilterCell({
    items: props?.items
      ? props?.items(languages)
      : languages.map((x) => ({ id: x.id, value: x.id, label: x.name })),
    options: {
      operator: languagesOperator,
    },
  })(props)
}
